import React from 'react';

import { Container, Notice, TabHeading } from './EggEmbryoInventory.styled';
import { useBreakpoints } from 'utilities/useBreakpoints';

import { Props } from './EggEmbryoInventory.types';
import { EggEmbryoInventoryStackView } from './EggEmbryoInventoryStackView';
import { EggEmbryoInventoryTableView } from './EggEmbryoInventoryTableView';

export const EggEmbryoInventory = ({ oocytes, notice }: Props) => {
  const { isMobile } = useBreakpoints();
  const hasOocytes = oocytes.length > 0;

  return (
    <Container>
      <TabHeading>Egg & Embryo Inventory Details</TabHeading>

      {notice && <Notice dangerouslySetInnerHTML={{ __html: notice }} />}

      {hasOocytes && isMobile ? <EggEmbryoInventoryStackView oocytes={oocytes} /> : null}

      {hasOocytes && !isMobile ? <EggEmbryoInventoryTableView oocytes={oocytes} /> : null}
    </Container>
  );
};
